<template>
  <div>
    <div
      v-show="isActiveMessage"
      ref="messageMin"
      v-resize="arrangeMessage"
      class="message--min"
    >
      <div ref="baseMessage" class="base-message--min">
        {{ minMessage }}
      </div>
      <span class="arranged-message--min">{{ minArrangedMessage }}</span>
      <span
        v-show="isShowExpandBtn"
        class="expand-btn"
        @click="showMoreMessage"
      >
        もっとみる
      </span>
    </div>
    <span v-show="!isActiveMessage" class="message--min--expand">{{
      message
    }}</span>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isActiveMessage: true,
      isShowExpandBtn: false,
      isShowFullMessage: false,
      minArrangedMessage: '',
      baseMessageDiv: null,
      cloneMessageDiv: null,
      messageClientHeight: ''
    }
  },
  computed: {
    minMessage() {
      return this.message.replace(/[\n]+/, '')
    },
    expandMessage() {
      return this.message.replace(/[\n]+/, '\n')
    }
  },
  mounted() {
    this.arrangeMessage()
  },
  methods: {
    showMoreMessage() {
      this.isActiveMessage = false
    },
    showDefaultMessage() {
      if (!this.isShowFullMessage) {
        this.trimmedMessage()
      }
    },
    arrangeMessage() {
      // メッセージ表示領域を複製する
      const baseMessageDiv = this.$refs.baseMessage
      this.baseMessageDiv = baseMessageDiv
      const cloneMessageDiv = this.generateCloneDiv(baseMessageDiv)
      this.cloneMessageDiv = cloneMessageDiv
      baseMessageDiv.after(cloneMessageDiv)

      // メッセージ領域の height を取得する
      const message = this.$refs.messageMin
      const messageClientHeight = this.calculateMessageHeight(message)
      this.messageClientHeight = messageClientHeight

      // divの高さ（48px, 2行を想定）に収まる場合はメッセージを全て表示する
      if (cloneMessageDiv.clientHeight <= messageClientHeight) {
        this.isShowFullMessage = true
        this.minArrangedMessage = cloneMessageDiv.text
      }
      cloneMessageDiv.remove()
      this.showDefaultMessage()
    },
    trimmedMessage() {
      const baseMessageDiv = this.baseMessageDiv
      const cloneMessageDiv = this.cloneMessageDiv

      const text = cloneMessageDiv.innerHTML

      baseMessageDiv.after(cloneMessageDiv)

      // css で指定した div の高さに収まるまで、メッセージ（clonedText）を1文字ずつ消す
      Array.from(text).some((_, index) => {
        cloneMessageDiv.innerHTML = text.substring(0, text.length - index)
        cloneMessageDiv.classList.add('clone-message--min')
        baseMessageDiv.after(cloneMessageDiv)
        const cloneSampleMessage = document.querySelector('.clone-message--min')
        return cloneSampleMessage.clientHeight <= this.messageClientHeight
      })
      const clonedText = cloneMessageDiv.innerHTML
      // 上記の while を抜けた時の clonedText が css で指定した div の高さに収まるメッセージとなる
      this.minArrangedMessage =
        clonedText.substring(0, clonedText.length - 6) + '...'
      // 元々の dom と複製した dom を消す
      cloneMessageDiv.remove()
      this.isShowExpandBtn = true
    },
    generateCloneDiv(baseMessageDiv) {
      const cloneMessageDiv = baseMessageDiv.cloneNode(true)

      cloneMessageDiv.style.width = baseMessageDiv.clientWidth + 'px'
      cloneMessageDiv.style.height = 'auto'
      cloneMessageDiv.text = baseMessageDiv.innerHTML

      return cloneMessageDiv
    },
    calculateMessageHeight(message) {
      // 'px' の2文字分を削除する
      const paddingTop = parseInt(
        window.getComputedStyle(message, null).paddingTop.slice(0, -2)
      )
      const paddingBottom = parseInt(
        window.getComputedStyle(message, null).paddingBottom.slice(0, -2)
      )
      return message.clientHeight - (paddingTop + paddingBottom)
    }
  }
}
</script>

<style scoped></style>
